import moment from 'moment'
import 'moment/min/locales'

export default moment
